import Vue from "vue";
import Router from "vue-router";
import { store } from "@/store";
import { HTTP } from "@/services/http";
import { serverBus } from "@/main";

// Admin pages
import Home from "@/views/Home";
import Plans from "@/views/Plans";
import Reports from "@/views/Reports";
import Financial from "@/views/Financial";
import Network from "@/views/Network/";
import Balance from "@/views/Balance";
import Profile from "@/views/Profile/User";
import UnilevelNetwork from "@/views/UnilevelNetwork/";
import Marketing from "@/views/Marketing";
import Invoices from "@/views/Invoices/List";
import InvoicesShow from "@/views/Invoices/Show";
import Leads from "@/views/Leads/";
import AdView from "@/views/AdView/";
import DashboardLayout from "@/layout/DashboardLayout";

// auth
import AuthLayout from "@/layout/AuthLayout";
import Login from "@/views/Auth/Login";
import Register from "@/views/Auth/Register";
import Forgot from "@/views/Auth/Forgot";
import TOS from "@/views/Auth/TOS";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "dashboard",
      component: DashboardLayout,
      children: [
        {
          path: "/dashboard",
          name: "Home",
          component: Home,
          meta: {
            requiresAuth: true,
            subscriptionRequired: true,
          },
        },
        {
          path: "my-referrals",
          name: "my-referrals",
          component: UnilevelNetwork,
          meta: {
            requiresAuth: true,
            subscriptionRequired: true,
          },
        },
        {
          path: "/plans",
          name: "Plans",
          component: Plans,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/reports",
          name: "Reports",
          component: Reports,
          meta: {
            requiresAuth: true,
            subscriptionRequired: true,
          },
        },
        {
          path: "/financial",
          name: "Financial",
          component: Financial,
          meta: {
            requiresAuth: true,
            subscriptionRequired: true,
          },
        },
        {
          path: "/network",
          name: "Network",
          component: Network,
          meta: {
            requiresAuth: true,
            subscriptionRequired: true,
          },
        },
        {
          path: "marketing",
          name: "Marketing.dashboard",
          component: Marketing,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/profile",
          name: "Profile.dashboard",
          component: Profile,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "/invoices",
          name: "Invoices",
          component: Invoices,
          meta: {
            requiresAuth: true,
            subscriptionRequired: true,
          },
        },
        {
          path: "/invoices/:id",
          name: "InvoicesShow",
          component: InvoicesShow,
          meta: {
            requiresAuth: true,
            subscriptionRequired: true,
          },
        },
        {
          path: "/leads",
          name: "Leads",
          component: Leads,
          meta: {
            requiresAuth: true,
            subscriptionRequired: true,
          },
        },
        {
          path: "/balance",
          name: "Balance",
          component: Balance,
          meta: {
            requiresAuth: true,
            subscriptionRequired: true,
          },
        },
        {
          path: "/ad-view",
          name: "AdView",
          component: AdView,
          meta: {
            requiresAuth: true,
            subscriptionRequired: true,
          },
        },
      ],
    },

    {
      path: "/",
      redirect: "dashboard",
      component: AuthLayout,
      children: [
        {
          path: "/login",
          name: "Login",
          component: Login,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: "/register",
          name: "Register",
          component: Register,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: "/register/lineBy/:sponsor",
          name: "RegisterBySponsor",
          component: Register,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: "/register/lineBy/:sponsor/branch/:position",
          name: "app.registerLink",
          component: Register,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: "/recovery",
          name: "Forgot",
          component: Forgot,
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: "/tos",
          name: "TOS",
          component: TOS,
          meta: {
            requiresAuth: false,
          },
        },
      ],
    },
  ],
});

router.afterEach(async (to) => {
  if (to.meta.requiresAuth) {
    store.dispatch("getUser");
  }
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!store.getters.authToken) {
      // return to login screen if not token found
      return next({ path: "/login" });
    } else {
      // ping server to check if session is still valid
      try {
        await HTTP({
          url: "/api/v1/client/sessions/user",
          method: "get",
          headers: {
            "content-type": "application/json",
            Authorization: store.getters.authToken,
          },
        });
      } catch (err) {
        serverBus.$emit("globalNotification", {
          m: "Your session has expired!",
        });
        if (err) next({ path: "/login" });
      }
      if (checkAccountActivation(to)) {
        return await next();
      } else {
        inactiveNotification();
      }
    }
  } else {
    return next();
  }
});

// verify if account is active and route requires active account
const checkAccountActivation = (to) => {
  return (
    (!to.meta.subscriptionRequired && true) || store.getters.currentUser.active
  );
};

// display toast notification with no active account notification
const inactiveNotification = () => {
  serverBus.$emit(
    "globalNotification",
    "Please Purchase a Pack to Activate Your Account!"
  );
};

export default router;
